<ng-select2
[class.opacity-65]="control.disabled === true"
[id]="id"
[dropdownParent]="dropdownParent"
[data]="dataSelect"
[options]="options"
[placeholder]="placeholder"
[formControl]="control">
</ng-select2>